import { render, staticRenderFns } from "./sosChart.vue?vue&type=template&id=0370a525&"
import script from "./sosChart.vue?vue&type=script&lang=js&"
export * from "./sosChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports